












import TextBoxSliceMaxLength from '@/views/atoms/TextBoxSliceMaxLength.vue'
import BlueButton from '@/views/atoms/BlueButton.vue'
import store from '@/store'
import PopupComfirmSave from '@/views/template/PopupComfirmSave.vue'
import ApiClient from '@/common/api'
import ErrorLabel from '@/views/atoms/ErrorLabel.vue'
import PopupComplete from '@/views/template/PopupComplete.vue'

export default
  components: {
    TextBoxSliceMaxLength
    BlueButton
    PopupComfirmSave
    ErrorLabel
    PopupComplete
  }
  data: () ->
    v: ""
    isShowPopup: {}
    complete: ''

  created: () ->
    store.dispatch('setErrors', [])
    api = new ApiClient()
    data = await api.get('/admin/daily_amount/value')
    @v= data.value

  methods: {
    change:(v) ->
      @v = v.val
    save:() ->
      param =
        value: @v
      api = new ApiClient()
      data = await api.post('/admin/daily_amount/save', param)
      @closePopup('save')
      if data.errors.length == 0
        @complete = '保存'
        @showPopup('complete')
    showPopup: (property) ->
      @$set(@isShowPopup, property, true)
    closePopup: (property) ->
      @$set(@isShowPopup, property, false)
  }
